import { firebase } from '@/firebase/firebase'
import modelProfile from "@/models/Profile"
import store from '../../store'

// setup auth
const auth = firebase.auth();

// firebase.auth().onAuthStateChanged((user)=>{
//   if (user) {
//     // User is signed in.
//     console.log('signed',user.email,user.uid);
//     store.commit('auth/setUid',user.uid)
//     store.dispatch('auth/loadProfile')
//     // firebase.firestore().collection("Profiles").doc(user.uid).get().then((doc)=>{
//     //   if (doc.exists) {
//     //     console.log('есть Profile',doc.data());
//     //     this.$store.state.auth.profile = new modelProfile(doc.data())
//     //   }  else {
//     //     console.log('no Profile');
//     //     this.$store.state.auth.profile = new modelProfile({displayName:usr.displayName,email:usr.email})
//     //   }
//     //})

//     // var displayName = user.displayName;
//     // var email = user.email;
//     // var emailVerified = user.emailVerified;
//     // var photoURL = user.photoURL;
//     // var isAnonymous = user.isAnonymous;
//     // var uid = user.uid;
//     // var providerData = user.providerData;
//     // // ...
//   } else {
//     // User is signed out.
//     // ...
//   }
// })
// catch error
const error = '';

// Google Auth Provider
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

//Facebook Auth Provider
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();

export default {
    namespaced: true,
    state: {
        auth: auth,
        uid: '',
        profile: new modelProfile({}),
        profileReady: false,
        error: error,
        googleAuthProvider: googleAuthProvider,
        facebookAuthProvider: facebookAuthProvider,
    },
    mutations: {
      setUid (state,data) {
        state.uid = data
      },
      setProfile (state,data) {
        state.profile = data
      },
      setProfileReady (state,data) {
        state.profileReady = data
      }
    },
    getters: {
      uid: state =>{
        return state.uid
      }
    },
    actions: {
        async login (context, user) {
            console.log('logining',user);
            return context.state.auth.signInWithEmailAndPassword(user.email, user.password).then((usr) => {
              console.log('login success',usr.uid,usr)
              context.commit('setUid',usr.uid)
              context.dispatch('loadProfile',usr)
            })
        },
        async loadProfile (context,user) {
          console.log('loading profile',context.state.uid, user.email);
          if (context.state.uid) {
            firebase.firestore().collection("Profiles").doc(context.state.uid).get().then((doc)=>{
              let p
              if (doc.exists) {
                console.log('есть Profile');
                p = new modelProfile(doc.data())
              }  else {
                console.log('no Profile');
                p = new modelProfile({})
              }
              p.displayName = user.displayName
              p.uid = user.uid
              p.email = user.email
              p.photoURL = user.photoURL || ''
              context.commit('setProfile',p)
              context.commit('setProfileReady',true)
            })
          }
        },
        logout (context) {
          console.log('loggin out',context.state.uid);

          context.commit('setUid','')
          context.commit('setProfileReady',false)

          return context.state.auth.signOut();
        },
        register (context, user) {
            return context.state.auth.createUserWithEmailAndPassword(user.email, user.password)
        },
        signInGoogle (context) {
            let provider = context.state.googleAuthProvider;
            return context.state.auth.signInWithPopup(provider)
        },
        signInFacebook (context) {
            let provider = context.state.facebookAuthProvider;
            return context.state.auth.signInWithPopup(provider)
        },
        updateProfilePicture (context, image) {
            return context.state.auth.currentUser.updateProfile({
                photoURL: image
            })
        },
        async saveProfile (context, newProfile) {
          let p = {
            FIO: newProfile.FIO,
            phone: newProfile.phone,
            city: newProfile.city,
            role: newProfile.role,
            passport: newProfile.passport,
            address: newProfile.address
          }

          return firebase.firestore().collection("Profiles").doc(context.state.uid).update(p)
             .then((doc)=>{
               console.log('profile saved');
               context.commit('setProfile',newProfile)
               return context.state.auth.currentUser.updateProfile({
                    displayName: p.FIO
                  })
               })
        }
    }
}



// WEBPACK FOOTER //
// ./storage/modules/myfirebase-auth/auth.js